"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FORM_TYPE = exports.CONTENT_TYPE = void 0;
const FORM_TYPE = exports.FORM_TYPE = {
  ContentBased: "contentbased",
  AlaCarte: "alacarte",
  Global: "global"
};
const CONTENT_TYPE = exports.CONTENT_TYPE = {
  CategoryGroup: "category",
  Collection: "collection"
};